import cn from 'classnames';
import { FieldInputProps, FieldMetaProps } from 'formik';
import React, { HTMLProps, ReactElement } from 'react';

import { handleInputOnInput, handleInputOnKeydown } from '~/utils/handle-input-events';

import styles from './CustomTextField.module.scss';

export interface CustomTextFieldProps extends HTMLProps<HTMLInputElement> {
  label?: string;
  suffixIcon?: ReactElement;
  field: FieldInputProps<any>;
  meta: FieldMetaProps<any>;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({ label, className, suffixIcon, field, meta, ...props }) => {
  const isNumberField = props?.type === 'number';
  return (
    <div className={cn(styles['text-field'], className)}>
      {label && (
        <label htmlFor={field.name} className={styles['text-field-label']}>
          {label}
        </label>
      )}
      <div className={cn(styles['input-wrapper'], meta.touched && meta.error && styles.error)}>
        {suffixIcon && <div className={styles['suffix-icon-wrapper']}>{suffixIcon}</div>}
        <input
          className={cn('form-control')}
          onInput={e => isNumberField && handleInputOnInput(e)}
          onKeyDown={e => isNumberField && handleInputOnKeydown(e)}
          {...field}
          {...props}
          name={field.name}
          onChange={props.onChange ?? field.onChange}
          autoComplete="off"
          aria-autocomplete="none"
        />
      </div>
      {!!meta.error && <div className="text-danger">{meta.error}</div>}
    </div>
  );
};

export default CustomTextField;
